export default {
    DeviceID: "b0:b8:67:c5:e3:a",
    AccessPointID: "38-0e-4d-bf-2b-0a",
    baseURL: "",
    LocationID: 360,
    maxCampaigns: 4,
}